import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'
import { apiV1 } from '@/shared/api/apiPrefix'
import { apiIdSchema } from '@/shared/schemas/ids.schema'
import { httpClient } from '@/shared/lib/httpClient'

/**
 * Minimal current-user identity, exposed from `shared/` so features (e.g. reservation)
 * need not import the `profile` feature - inter-feature coupling is forbidden (AC-F04).
 */
// Built lazily: this module lands in a lazy chunk that can evaluate before `apiIdSchema` is initialised.
const buildCurrentUserSchema = () =>
  z.object({
    id: apiIdSchema,
    name: z.string(),
    email: z.string(),
  })

export type CurrentUser = z.infer<ReturnType<typeof buildCurrentUserSchema>>

export const currentUserQueryKey = ['shared', 'current-user'] as const

export function useCurrentUser() {
  return useQuery({
    queryKey: currentUserQueryKey,
    queryFn: async (): Promise<CurrentUser> => {
      const res = await httpClient.get<unknown>(apiV1('/me'))

      return z.object({ data: buildCurrentUserSchema() }).parse(res.data).data
    },
  })
}
